import { render, staticRenderFns } from "./Fußzeile.vue?vue&type=template&id=597bb124&scoped=true"
import script from "./Fußzeile.vue?vue&type=script&lang=js"
export * from "./Fußzeile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597bb124",
  null
  
)

export default component.exports